import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../theme";
import { KeyboardArrowUp } from "@mui/icons-material";

interface MemoryBookMinimisedPillProps {
  overdueCount: number;
  inDangerCount: number;
  onExpand: () => void;
}

const MemoryBookMinimisedPill = ({
  overdueCount,
  inDangerCount,
  onExpand,
}: MemoryBookMinimisedPillProps) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      sx={{
        cursor: "pointer",
        // mt: "auto",
      }}
      onClick={onExpand}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          borderRadius: 50,
          backgroundColor: colors.primary[800],
          border: `1px solid ${colors.primary[300]}30`,
          overflow: "hidden",
          transition: "box-shadow 0.2s ease",
          "&:hover": { boxShadow: "0 4px 16px rgba(0,0,0,0.2)" },
        }}
      >
        {/* Label */}
        <Box sx={{ px: 2.5, py: 1.5 }}>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "0.75rem",
              letterSpacing: "0.08em",
              color: colors.primary[700],
              textTransform: "uppercase",
              whiteSpace: "nowrap",
            }}
          >
            Memory Books
          </Typography>
        </Box>

        {/* Divider */}
        <Box
          sx={{
            width: "1px",
            height: 40,
            backgroundColor: colors.primary[300] + "40",
          }}
        />

        {/* Overdue */}
        <Box
          sx={{
            px: 2,
            py: 1.5,
            display: "flex",
            alignItems: "center",
            gap: 0.8,
          }}
        >
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: "#E11D48",
            }}
          />
          <Typography
            sx={{ fontWeight: 700, fontSize: "0.85rem", color: "#E11D48" }}
          >
            {overdueCount}
          </Typography>
          <Typography sx={{ fontSize: "0.7rem", color: colors.primary[700] }}>
            overdue
          </Typography>
        </Box>

        {/* Divider */}
        <Box
          sx={{
            width: "1px",
            height: 40,
            backgroundColor: colors.primary[300] + "40",
          }}
        />

        {/* In Danger */}
        <Box
          sx={{
            px: 2,
            py: 1.5,
            display: "flex",
            alignItems: "center",
            gap: 0.8,
          }}
        >
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: "#f59e0b",
            }}
          />
          <Typography
            sx={{ fontWeight: 700, fontSize: "0.85rem", color: "#f59e0b" }}
          >
            {inDangerCount}
          </Typography>
          <Typography sx={{ fontSize: "0.7rem", color: colors.primary[700] }}>
            in danger
          </Typography>
        </Box>
        {/* Expand icon */}
        <Box sx={{ px: 1.5, display: "flex", alignItems: "center" }}>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation(); // prevent double-firing with parent onClick
              onExpand();
            }}
            sx={{
              color: colors.primary[100], // use a lighter color, same as the text
              p: 0.5,
              ml: -0.5,
              flexShrink: 0, // prevent it from being squeezed out
              "&:hover": { color: "white", backgroundColor: "transparent" },
            }}
          >
            <KeyboardArrowUp sx={{ fontSize: 18 }} />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default MemoryBookMinimisedPill;
